import { axiosInstance } from "./axiosInstance";

class CommonService {
  async get(url) {
    return new Promise(async function (resolve, reject) {
      await axiosInstance({
        method: "get",
        url: url,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          if (err.response) {
            if (err.response.status === 401) {
              alert(err?.response?.message);
              localStorage.removeItem("cacheData");
            } else if (err.response.status === 404) {
              console.log(err?.response?.message);
            } else {
            console.log(err);
            }
          } else {
          console.log(err);
          }
        });
    });
  }

  async delete(url) {
    return new Promise(async function (resolve, reject) {
      await axiosInstance({
        method: "delete",
        url: url,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  async post(url, data) {
    return new Promise(async function (resolve, reject) {
      await axiosInstance({
        method: "post",
        url,
        data,
        headers: {
          Accept: "*/*",
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          console.log("error: " + err);
        });
    });
  }

  async put(url, data) {
    return new Promise(async function (resolve, reject) {
      await axiosInstance({
        method: "put",
        url: url,
        data,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }


  
}

const commonServiceInstance = new CommonService()

export default commonServiceInstance;
